// Takes in a normal string (not camelCase of kebab-case)
// Returns 'Title Case'

export function useTitleCase(string) {
  if (!string) return "";
  // Insert space before camelCase capitals (e.g., videoAccess -> video Access)
  const withSpaces = string.replace(/([a-z0-9])([A-Z])/g, "$1 $2");
  // Replace hyphens/underscores with spaces  (e.g., video-access -> video access)
  const normalized = withSpaces.replace(/[-_]+/g, " ");
  // Capitalize each word
  return normalized
    .split(/\s+/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

// Prose in title case (2026-10-14; useTitleCase above is for identifiers, which it splits): each
// word capitalised, except small words in the middle; a word with capitals already ("AI",
// "DataVis", "mRNA") as written; hyphens kept ("AI-driven" → "AI-Driven"). "Ballet of the birds
// (preview)" → "Ballet of the Birds (Preview)"
const SMALL_WORDS = new Set([
  "a", "an", "and", "as", "at", "but", "by", "for", "from", "in", "into", "nor", "of", "on", "or",
  "per", "the", "to", "via", "vs", "with"
]);

function getCapitalised(word) {
  if (/[A-Z]/.test(word)) return word;
  return word.replace(/[a-z]/, (letter) => letter.toUpperCase());
}

function getTitleWord(word, isEdge) {
  const bare = word.replace(/^\W+|\W+$/g, "").toLowerCase();
  if (!isEdge && SMALL_WORDS.has(bare)) return word;
  return word.split("-").map(getCapitalised).join("-");
}

export function getTitleCase(text) {
  const words = String(text || "").split(/\s+/).filter(Boolean);
  return words.map((word, index) => {
    const isEdge = index === 0 || index === words.length - 1 || /[:(]$/.test(words[index - 1]);
    return getTitleWord(word, isEdge || word.startsWith("("));
  }).join(" ");
}
